import { Component, OnInit } from '@angular/core';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import {
  UserProperty,
  CacheConstant,
  CMSPages
} from '../../../core/constants/app.constant';
import { AppConfigService, Configuration } from '../../../core/services/init/app-config.service';
import { UserService } from '../../../core/services/user.service';
import { Footer } from '../../../shared/models/footer';
import { ProductSearchCriteria, ProductSearchRequest } from '../../../shared/models/product-search-criteria';

import { ProductConstant } from '../product-messages';
import {
  AddProductToFavRequest,
  ItemNum,
  Product,
  ProductFilter,
  SusbscribedProducts
} from '../../../shared/models/product';
import { BaseComponent } from '../../../app.base.component';
import { ProductsService } from '../products.service';
import { AppCacheService } from '../../../core/services/cache/app-cache.service';
import { PagedDataSource } from '../../../shared/models/paged-data-source';
import { CaseQtyAlertComponent } from '../inventory-alert/case-qty-alert/case-qty-alert.component';
import { CmsService } from '../../../core/services/cms.service';
import { AppUtilService } from '../../../core/utils/app-util.service';
import { StaticPageContent } from '../../../shared/models/cms';
import { ActivatedRoute } from '@angular/router';
import { PublisherService } from '../../../core/services/publisher.service';
@Component({

  selector: 'par-product-search-unauth',
  templateUrl: './product-search-unauth.component.html',
  styleUrls: ['./product-search-unauth.component.scss']
})

export class ProductSearchUnauthComponent extends BaseComponent
  implements OnInit {

  /***************Properties***************/

  products: Product[] = new Array<Product>();
  pagedProductList: Product[] = new Array<Product>();
  tempPagedProductList: Product[] = new Array<Product>();
  noProductsFound: Boolean = true;
  showProductOptions: Boolean = false;
  showPagination: Boolean = false;
  mobileSearchTrigger: Boolean = false;
  showSpinner: boolean;
  productsLoaded: Boolean = false;
  enableAddToCart: Boolean = false;
  productsOnAddToCart: Boolean = false;
  applyingFilters: Boolean = false;
  private productList: Product[] = new Array<Product>();

  envProperties = this.cache.get(CacheConstant.Env_Properties);
  websiteName: string = this.envProperties.theme;
  qtyLength = this.envProperties.qtyFieldLength;
  isSubscriptionEnabled: boolean = this.envProperties.subscriptionEnabled;
  elasticSearchFlag: boolean = this.envProperties.elasticSearchFlag ? this.envProperties.elasticSearchFlag.toBoolean() : false;
  searchValue: string;
  entity = `${this.websiteName + 'Footer'}`;
  footerData: Footer;
  private filterInStockProductsForMajor: Product[] = new Array<Product>();
  messages = {
    noResultFoundMessage: ProductConstant.Messages.NoSearchResultFoundMessage
  };
  productFilterOptions = {
    sortBy: '',
    direction: '',
    pageSizes: [10, 20, 50, 100],
    selectedPage: 1,
    selectedPageSize: 10,
    totalPages: 0
  };
  caseQtyMismatch = [];

  searchCriteria: ProductSearchCriteria = {
    advSearchFilter: 0,
    pageSize: 10,
    advSearchType: null,
    billToNumber: null,
    searchVal: '',
    shipToNum: null,
    soldToNum: null,
    userDetailNum: 0
  };

  searchRequest: any = {
    buId: 0,
    pageSize: 10,
    searchKeyword: '',
    shipToNum: null,
    soldToNum: null,
    userDetailNum: 0,
    pageNo: 0,
    facets: {
      strength: [],
      form: [],
      labelsize: [],
      accountType: []
    },
    sortOrder: null,
    sortParam: null
  };

  filters: ProductFilter = {
    config: { applied: false },
    stock: { available: false, enabled: true },
    strength: { values: [], selected: '' },
    size: { values: [], selected: '' },
    form: { values: [], selected: '' },
    manufacturer: { values: [], selected: '' },
   accountType: { values: [],selected: ''}
  };

  addProductToFavRequest: AddProductToFavRequest;
  userDetailNum: null;
  favLists: any;
  item: ItemNum;
  isFromApp: boolean = false;
  processing: boolean = false;
  caseAlertObject: any;
  isFullCatalogSearch: boolean = true;
  productSearchPageVO: any;
  productSearchFacets: any;
  subscribeProductList: Product[] = [];
  qtyAlert: string;
  itemId: number;
  subscribedItems: SusbscribedProducts = new SusbscribedProducts();
  detailsLoading: boolean = false;
  invalidSubscribedItem: SusbscribedProducts = new SusbscribedProducts();
  inValidItemFlag: boolean = false;
  cachedata: any;
  cacheSubscribedData: any;
  isAuthenticated = false;
  isFormHide = false;
  params
  content: any;
  constructor(
    private productService: ProductsService,
    private userService: UserService,
    private cache: AppCacheService,
    deviceDetectorService: DeviceDetectorService,
    public dialog: MatDialog,
    private appConfig: AppConfigService,
    private cmsService: CmsService,
    private route: ActivatedRoute,
  ) {
    super(deviceDetectorService, cache, appConfig);
    this.footerData = super.getFooterData();
  }
  ngOnInit() {

    this.getCmsContent();
    this.route.params.subscribe(
      (params: any) => {
        if (this.isAuthenticated == false) {
          // PublisherService.changeBannerHeader('Product Catalog');
          // PublisherService.changeBannerContent(
          //   '<p>To access our Product Catalog, please select the option that best describes you. </p>'
          // );
        }
          if (Object.keys(params).length > 0) {
          this.onSearchTrigger(params.searchValue, params);
        }
      }
    );

  }

  getProductsFilterByCatolog(filterBy: string = 'O') {
    this.resetFields();
    this.isFormHide = true;
    this.productService.getProductFilterByCatalog(filterBy).subscribe((response: any) => {

      if (response.itemList != undefined && response.itemList.length > 0) {
        response.itemList=response.itemList.sort((a,b)=>a.description>b.description?1:-1);
        this.isFullCatalogSearch = true;
        this.productSearchPageVO = response.pageVo;
        this.productSearchFacets = response.facet;
        this.noProductsFound = response.totalRecords <= 0;
        this.showProductOptions = response.totalRecords > 0 && response.itemList.length > 0;
        this.showPagination = response.totalRecords > 0 && response.itemList.length > 0;
        response.itemList.forEach((product: Product) => {
          this.updateProductConfig(product);
          this.productList.push(product);
          this.products.push(product);
        });

        this.productFilterOptions.totalPages = Math.ceil(
          response.pageVo.total_results / this.productFilterOptions.selectedPageSize
        );
        this.filterProducts();
        this.tempPagedProductList = this.pagedProductList;

        if (this.websiteName == 'Major') {
          this.getProductImageMajor();
        }
        !this.applyingFilters ? this.setFilterValues() : null;
        this.productsLoaded = true;
      }
      else {
        this.noProductsFound = true;
        this.productsLoaded = true;
      }
      this.processing = false;
      this.applyingFilters = false;
    }
    );
  }

  resetFields() {
    this.productsLoaded = false;
    this.showProductOptions = this.applyingFilters ? true : false;
    this.showPagination = false;
    this.pagedProductList = [];
    this.tempPagedProductList = [];
    this.products = [];
    this.productList = [];
    this.processing = true;
  }


  getProducts(searchParam) {

    this.resetFields();
    this.productService.getProductSearch(searchParam).subscribe((response: any) => {

      if (response.itemList != undefined && response.itemList.length > 0) {

        this.isFullCatalogSearch = true;
        this.productSearchPageVO = response.pageVo;
        this.productSearchFacets = response.facet;
        this.noProductsFound = response.totalRecords <= 0;
        this.showProductOptions = response.totalRecords > 0 && response.itemList.length > 0;
        this.showPagination = response.totalRecords > 0 && response.itemList.length > 0;
        response.itemList.forEach((product: Product) => {
          this.updateProductConfig(product);
          this.productList.push(product);
          this.products.push(product);
        });

        this.productFilterOptions.totalPages = Math.ceil(
          response.pageVo.total_results / this.productFilterOptions.selectedPageSize
        );
        this.filterProducts();
        this.tempPagedProductList = this.pagedProductList;

        if (this.websiteName == 'Major') {
          this.getProductImageMajor();
        }
        !this.applyingFilters ? this.setFilterValues() : null;
        this.productsLoaded = true;
      }
      else {
        this.noProductsFound = true;
        this.productsLoaded = true;
      }
      this.processing = false;
      this.applyingFilters = false;
    }
    );
  }

  private updateProductConfig(product: Product) {
    product.color = product.color?.trim() ? product.color : 'N/A' ;
    product.shape = product.shape?.trim() ? product.shape : 'N/A' ;
  }


  onProductSorts() {
    const sortBy = this.productFilterOptions.sortBy;
    const products = this.products;

    if (products.length > 1) {
      products.sort(function (a, b) {
        if (a[sortBy] < b[sortBy]) {
          return -1;
        }
        if (a[sortBy] > b[sortBy]) {
          return 1;
        }
        return 0;
      });

      if (this.productFilterOptions.direction === 'des') {
        products.reverse();
      }

      this.products = products;
      this.filterProducts();
      this.getProductImageMajor();
    }
  }

  private filterProducts() {
    let pageSize = Number(this.productFilterOptions.selectedPageSize);
    this.pagedProductList = new Array<Product>();
    if (this.products.length < this.productFilterOptions.selectedPageSize) {
      pageSize = this.products.length;
    }
    for (
      let i = (this.productFilterOptions.selectedPage - 1) * pageSize;
      i < (this.productFilterOptions.selectedPage - 1) * pageSize + pageSize;
      i++
    ) {
      if (i === this.products.length) {
        break;
      }
      this.products[i].imgData = '/assets/images/no-img-available.jpg';
      this.pagedProductList.push(this.products[i]);
    }
  }

  private getProductImageMajor() {
    if (this.pagedProductList.length > 0 && !this.isMobileDevice()) {
      const itemList: Array<any> = [];
      this.pagedProductList.forEach(product => {
        itemList.push(product.itemId);
      });
      this.productService
        .getProductImageRef(itemList, false)
        .subscribe((response: any) => {
          if (!response.hasError) {
            response.forEach(item => {
              if (item.itemNum) {
                const product = this.pagedProductList.filter(
                  p => p.itemId === item.itemNum
                )[0];

                product.imgData = this.appConfig.get(Configuration.IMAGE_BASE_URL) + '/original/BUID-2/'
                  + item.imageDetails[0].imageFileName;

              }
            });
          }
        });
    }
  }

  private setFilterValues() {
    const strengths = [],
      forms = [],
      accountType = [],
      sizes = [];

    this.filters.config.applied = false;
    this.filters.stock.available = false;

    if (this.products && this.products.length > 0) {
      if (this.productSearchFacets != undefined && Object.keys(this.productSearchFacets).length != 0) {

        (this.productSearchFacets.form != null && this.productSearchFacets.form[0].data.length != 0) ? this.productSearchFacets.form[0].data.forEach(form => {
          forms.push(form.value)
        }) : null;

        (this.productSearchFacets.accountType != null && this.productSearchFacets.accountType[0].data.length != 0) ? this.productSearchFacets.accountType[0].data.forEach(accountType => {
          accountType.push(accountType.value)
        }) : null;

        (this.productSearchFacets.labelsize != null && this.productSearchFacets.labelsize[0].data.length != 0) ? this.productSearchFacets.labelsize[0].data.forEach(size => {
          sizes.push(size.value)
        }) : null;

        (this.productSearchFacets.strength != null && this.productSearchFacets.strength[0].data.length != 0) ? this.productSearchFacets.strength[0].data.forEach(strength => {
          strengths.push(strength.value)
        }) : null;
      }
      else {
        this.products.forEach(p => {
          strengths.push(p.strength);
          forms.push(p.form);
          sizes.push(p.labelSize);
        });
      }

      this.filters.strength = {
        values: this.distinctSortFilter(strengths),
        selected: ''
      };

      this.filters.form = {
        values: this.distinctSortFilter(forms),
        selected: ''
      };

      this.filters.size = {
        values: this.distinctSortFilter(sizes),
        selected: ''
      };
    }
  }
  private distinctSortFilter(values: Array<any>) {
    values = values.distinct();
    values.sort();
    return values;
  }

  onProductPageChange(pagedDataSource: PagedDataSource) {
    const isMobileSearch = this.isMobileDevice();
    this.getProductDataOnPageChange(pagedDataSource, isMobileSearch);
  }

  //Get product data after the page change
  getProductDataOnPageChange(pagedDataSource: PagedDataSource, isMobileSearch: boolean) {
    if (
      (isMobileSearch &&
        pagedDataSource.currentPage &&
        pagedDataSource.currentPageSize) &&
      (!this.mobileSearchTrigger) || this.isFromApp) {
      this.mobileSearchTrigger = true;
      this.pagedProductList =
        pagedDataSource.dataSource || this.pagedProductList;


    }
    else if (

      pagedDataSource.currentPage &&
      pagedDataSource.currentPageSize &&
      (pagedDataSource.currentPage !== this.productFilterOptions.selectedPage ||
        pagedDataSource.currentPageSize.toString() !==
        this.productFilterOptions.selectedPageSize.toString())
    ) {
      this.productFilterOptions.selectedPage =
        pagedDataSource.currentPage || this.productFilterOptions.selectedPage;
      this.productFilterOptions.selectedPageSize =
        pagedDataSource.currentPageSize || this.productFilterOptions.selectedPageSize;
      this.pagedProductList =
        pagedDataSource.dataSource || this.pagedProductList;
      this.filterProducts();
      this.getProductImageMajor();
    }

  }



  private filterProductsByAttributes() {
    const strength = this.filters.strength.selected,
      form = this.filters.form.selected,
      size = this.filters.size.selected,
      accountType=this.filters.accountType.selected;
    if (strength || form || size||accountType) {
      this.filters.config.applied = true;
      this.products = this.productList.filter(p => {
        return (
          (!strength || strength === 'all' || p.strength === strength) &&
          (!form || form === 'all' || p.form === form) &&
          (!size || size === 'all' || p.labelSize === size)&&(!accountType || accountType === 'all' || p.labelType === accountType)
        );
      });

    } else {
      this.filters.config.applied = false;
      this.products = Object.clone(this.productList);
    }
    this.noProductsFound = this.products.length <= 0;
    this.showPagination = this.products.length > 0;
  }
  private resetFilters() {
    this.filters.config.applied = false;
    this.applyingFilters = true;
    this.searchRequest.facets.form = [];
    this.searchRequest.facets.labelsize = [];
    this.searchRequest.facets.accountType = [];
    this.searchRequest.facets.strength = [];
    this.searchRequest.pageNo = 0;
    this.productFilterOptions.selectedPage = 1;

  }
  private resetSortPagination() {
    this.productFilterOptions = {
      sortBy: 'description',
      direction: 'asc',
      pageSizes: [10, 20, 50, 100],
      selectedPage: 1,
      selectedPageSize: 10,
      totalPages: 0
    };
  }
  onProductFilter() {
    this.filterProductsByAttributes();
    this.filterProducts();
    this.getProductImageMajor();
  }

  onClearFilterClick() {
    this.clearFilter();
    this.filterProductsByAttributes();
  }
  clearFilter() {
    this.filters.strength.selected = '';
    this.filters.size.selected = '';
    this.filters.form.selected = '';
    this.filters.accountType.selected = '';
    this.filters.stock.available = false;
    this.searchRequest.facets.strength = [];
    this.searchRequest.facets.form = [];
    this.searchRequest.facets.labelsize = [];
    this.searchRequest.sortParam = null;
    this.searchRequest.sortOrder = null;
    this.productFilterOptions.sortBy = "description";
    this.productFilterOptions.direction = "asc";
    this.searchRequest.pageNo = 0;
    this.productFilterOptions.selectedPage = 1;
    this.caseQtyMismatch = [];
  }

  disableFilter(filter, value) {
    if (this.productSearchFacets != undefined && Object.keys(this.productSearchFacets).length != 0 && !this.filters.config.applied) {
      return true;
    } else {
      return this.products.find((product) => {
        return product[filter] === value;
      });
    }
  }
  getCmsContent() {
    let cmsPageName = this.isAuthenticated ? CMSPages.Home : CMSPages.Login;
    let templateNum = this.envProperties.cmsPageConfigVO.staticPageTemplateId;
    let pageSeqNumber = this.isAuthenticated ? this.envProperties.cmsPageConfigVO.userNotificAuthenticatedSeqNo : this.envProperties.cmsPageConfigVO.productCatalogUnauthenticatedSeqNo;
    this.cmsService.getCmsStaticPageTemplateByPageNameAndTemplateNum(cmsPageName, this.envProperties.buId, templateNum, pageSeqNumber).subscribe((response: any) => {
      if (!response.hasError && response.length > 0) {
        let staticPageContent: StaticPageContent = response[0];
        this.content = JSON.parse(staticPageContent.contentStructure);

      }
    });
  }
  downloadFile() {
    let documentNum = this.content.recordList[0].documentNum;
    this.cmsService.getCmsMediaByDocNum(documentNum).subscribe((res: any) => {
      AppUtilService.redirectToExternalLink(res.mediaLink);
    })
  }
  private onSearchTrigger(searchValue, params) {
    this.searchValue = params.searchValue;
    if (this.websiteName == 'Major') {
      this.searchCriteria.searchVal = searchValue
        ? searchValue.toString().decode()
          ? searchValue
            .toString()
            .decode()
            .replace(/%/g, ' ')
            .replace(/-/g, '')
          // .replace(/\b0+/g, '')
          : searchValue.toString().decode()
        : null;
    }
    this.clearFilter();
    this.resetSortPagination();
    this.getProducts(this.searchCriteria.searchVal);
  }
  /***************Private Methods***************/
}
